import React from 'react'
import { Link } from 'react-router-dom'
import { addToCart } from '../../../user/features/cart/cartSlice' // Updated import path
import { useDispatch, useSelector } from 'react-redux'
import Notification from '../../../Helpers/Notification'
import { useAuth } from '../../context/AuthContext'
import { useNavigate } from 'react-router-dom'

const ProductCard = ({ product, column = 3 }) => {
    const dispatch = useDispatch()
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()

    // Access the cart items from the Redux state with correct path
    const cartItems = useSelector(state => state.cart?.items || [])
    const inCart = cartItems.some(item=>item.id===product.id)

    const handleAddToCart = () => {
        if(!isAuthenticated){
            navigate('/login')
            return
        }
        // Add product with quantity 1
        const productWithQuantity = { ...product, quantity: 1 }
        dispatch(addToCart(productWithQuantity))
        Notification('success', 'Product added to cart successfully!')
    }

    const isWithinAMonth = (dateString) => {
        const date = new Date(dateString);
        const currentDate = new Date();
        const timeDifference = currentDate - date;
        const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert milliseconds to days
        return daysDifference <= 30;
    };

    return (
        <div className={`col-lg-${column} col-md-6 col-sm-4 col-6 mb-4`} key={product._id}>
            <div className="product-card">
                <div className="card-img-container">
                    <img
                        className="card-img"
                        alt="Product"
                        src={(() => {
                          // Handle multiple possible shapes for image data
                          if (product?.main_image) {
                            // Object shape { url: "filename.jpg" }
                            if (typeof product.main_image === 'object' && product.main_image.url) {
                              return `${process.env.REACT_APP_API_URL}/uploads/products/${product.main_image.url}`
                            }
                            // String shape "filename.jpg"
                            if (typeof product.main_image === 'string') {
                              return `${process.env.REACT_APP_API_URL}/uploads/products/${product.main_image}`
                            }
                          }

                          // Pre-resolved absolute url from backend
                          if (product.full_main_image) {
                            return product.full_main_image
                          }

                          // Legacy field
                          if (product.full_image) {
                            return product.full_image
                          }

                          // Fallback placeholder
                          return '/assets/images/no-image.png'
                        })()}
                    />
                    {isWithinAMonth(product.created_at) && isWithinAMonth(product.updated_at) && (
                        <span className="new-tag">new</span>
                    )}
                    <div className="card-overlay">
                        {inCart ? (
                          <button onClick={()=>navigate('/checkout')} className="action-button">
                            <img alt="Cart" src="/assets/images/svg/cart.svg" />
                            Go to Cart
                          </button>
                        ) : (
                          <button onClick={handleAddToCart} className="action-button">
                            <img alt="Add to Cart" src="/assets/images/svg/cart.svg" />
                            Add To Cart
                          </button>
                        )}
                        <Link to={`/products/view/${product._id}`} className="action-button">
                            <img alt="View Product" src="/assets/images/svg/view.svg" />
                            View Product
                        </Link>
                    </div>
                </div>
                <div className="card-details">
                    <h4 className="card-name">{product.title}</h4>
                    <p className="card-price">
                        <span className="current-price">₹ {product.price}</span>
                        {product.del_price && <del className="original-price">₹ {product.del_price}</del>}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ProductCard
